import { Outlet } from "react-router-dom";
import { Grid, IconButton } from "@mui/material";
import AdminSidePanel from "../Components/SidePanel/AdminSidePanel";
import NavBar from "../Components/NavBar/NavBar";
import SignUpDialog from "../Components/Auth/SignUpDialog";
import SigninDialog from "../Components/Auth/SignInDialog";
import { useEffect, useState } from "react";
import { Menu } from "@mui/icons-material";
import SidePanel from "../Components/SidePanel/SidePanel";

const AdminLayout = ({ children }) => {
  const [roles, setRoles] = useState("");

  useEffect(() => {
    const getRoles = () => {
      if (typeof window !== undefined) {
        setRoles(sessionStorage.getItem("role"));
      }
    };
    getRoles();
  }, []);

  const list = [
    {
      id: 1,
      name: "User Management",
      link: "/admin/user",
      validation: roles?.split(",").includes("PRIV_ECOM_USERDISPLAY"),
    },
    {
      id: 2,
      name: "Category Management",
      link: "/admin/category",
      validation: roles?.split(",").includes("PRIV_ECOM_CATEGORYDISPLAY"),
    },
    {
      id: 3,
      name: "Item Management",
      link: "/admin/item",
      validation: roles?.split(",").includes("PRIV_ECOM_ITEMDISPLAY"),
    },
    {
      id: 4,
      name: "Order Management",
      link: "/admin/order",
      validation: roles?.split(",").includes("PRIV_ECOM_ORDERDISPLAY"),
    },
    {
      id: 5,
      name: "Organization Management",
      link: "/admin/organization",
      validation: roles?.split(",").includes("PRIV_ECOM_ORGANIZATIONDISPLAY"),
    },
    {
      id: 6,
      name: "Policy Management",
      link: "/admin/policy",
      validation: roles?.split(",").includes("PRIV_ECOM_POLICYDISPLAY"),
    },
    {
      id: 7,
      name: "Seller Management",
      link: "/admin/seller",
      validation: roles?.split(",").includes("PRIV_ECOM_SELLERDISPLAY"),
    },
    {
      id: 8,
      name: "Brand Management",
      link: "/admin/brand",
      validation: roles?.split(",").includes("PRIV_ECOM_BRANDDISPLAY"),
    },
    {
      id: 9,
      name: "Auto-Add Management",
      link: "/admin/autoAdd",
      validation: roles?.split(",").includes("PRIV_ECOM_AUTOADDDISPLAY"),
    },
    {
      id: 10,
      name: "Offer Management",
      link: "/admin/offer",
      validation: roles?.split(",").includes("PRIV_ECOM_OFFERDISPLAY"),
    },
    {
      id: 11,
      name: "Theme Management",
      link: "/admin/theme",
      validation: roles?.split(",").includes("PRIV_ECOM_THEMEDISPLAY"),
    },
    {
      id: 12,
      name: "Coupon Management",
      link: "/admin/coupon",
      validation: roles?.split(",").includes("PRIV_ECOM_COUPONDISPLAY"),
    },
    {
      id: 13,
      name: "Currency Management",
      link: "/admin/currency",
      validation: roles?.split(",").includes("PRIV_ECOM_CURRENCYDISPLAY"),
    },
    {
      id: 14,
      name: "BR Management",
      link: "/admin/role",
      validation: roles?.split(",").includes("PRIV_ECOM_BRDISPLAY"),
    },
    {
      id: 15,
      name: "Privilege Management",
      link: "/admin/privilege",
      validation: roles?.split(",").includes("PRIV_ECOM_PRIVILEGEDISPLAY"),
    },
    {
      id: 16,
      name: "Br-Priv Mapping",
      link: "/admin/brPrivMapping",
      validation: roles?.split(",").includes("PRIV_ECOM_MAPPINGDISPLAY"),
    },
  ];

  const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);

  const toggleSidePanel = () => {
    setIsSidePanelOpen(!isSidePanelOpen);
  };

  return (
    <>
      <Grid container spacing={0}>
        <NavBar
          style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 900 }}
        />
        {/* <Grid item xs={12} md={1}>
          <IconButton
            onClick={toggleSidePanel}
            sx={{
              display: { md: "none" },
              zIndex: 1000,
              position: "fixed",
              top: "1rem",
            }}
          >
            <Menu />
          </IconButton>
          <SidePanel open={isSidePanelOpen} onClose={toggleSidePanel} />
        </Grid> */}
        <Grid item xs={0} md={2}>
          {roles?.split(",").includes("PRIV_ECOM_ADMINDISPLAY") && (
            <AdminSidePanel />
          )}
        </Grid>
        <Grid item xs={12} md={10}>
          <Outlet />
        </Grid>{" "}
        <SignUpDialog /> <SigninDialog />
      </Grid>
    </>
  );
};

export default AdminLayout;
